<template lang="pug">
div.small-margin
  b-field(:label="initBlock.config.label" label-position="on-border")
    b-taginput(v-model='selectedTags' :data='tags' autocomplete :allow-new='false' :open-on-focus='true' icon='label' placeholder='Kategorie hinzufügen' @typing='getFilteredTags')

</template>

<script>
export default {
  components: {

  },
  props: {
    parentKey: String,
    initBlock: {
      type: Object,
      default() {
        return {
          value: {
            tags: []
          },
          config: null
        }
      }
    }
  },
  data() {
    return {
      selectedTags: [],
      tags: [],
      filteredTags: []
    };
  },
  watch: {
    selectedTags(newVal) {
      if (JSON.stringify(newVal) === this.initBlock.value.tags) return;
      this.updateValue(JSON.stringify(newVal));
    }
  },
  methods: {
    getFilteredTags(text) {
      const tagArray = this.initBlock.config.validation.split(',');
      this.filteredTags = tagArray.filter((option) => {
          return option
              .toString()
              .toLowerCase()
              .indexOf(text.toLowerCase()) >= 0
      });
    },
    updateValue(e) {
      this.$root.$emit('updateBlockJSON', {
        name: this.initBlock.name,
        key: this.initBlock.key,
        parentKey: this.parentKey,
        value: {
          tags: e
        }
      });
    }
  },
  mounted() {
    this.selectedTags = this.initBlock.value.tags && this.initBlock.value.tags[0] ? JSON.parse(this.initBlock.value.tags) : [];
    this.filteredTags = this.initBlock.config.validation.split(',');
    this.tags = this.initBlock.config.validation.split(',');
  }
}
</script>

<style lang="scss" scoped>
.small-margin {
  margin-top: 16px;
  margin-bottom: 16px;
}
</style>